module.exports = __webpack_public_path__ + "img/horizontal_6_4_6000.50203774.png";